import { Flow } from 'signup-constants/Flow';
import { Intent } from 'signup-constants/Intent';
import { isGoogleSignup } from '../app/verificationTypeSelectors';
import { getIntentLink } from '../intents/intentSelectors';
import { getIntentKey } from '../routing/getIntentKey';
import { getIsNewUser } from '../store/app/selectors';
import { getIsMobile } from '../utils/deviceUtils';
import { isFlow } from '../utils/isFlow';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { getIsNewUserExperiment } from './ExperimentUtils';
import { getIsComingFromEmailSignatureGenerator } from './acq0139/acq0139Utils';
import { enrollOnFlow } from './experimentDefaults';
import { getShouldOverrideToGosu0002Variant } from './gosu0002/getShouldOverrideToVariant';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();

const getIsNotMobile = () => !getIsMobile();

const Experiments = new Map([[ExperimentKeys.BIAB004, {
  shouldEnroll: state => {
    return isFlow(Flow.Crm) && !getIntentLink(state);
  }
}], [ExperimentKeys.GOSU0002, {
  shouldEnroll: () => {
    const isCrmFlow = isFlow(Flow.Crm);
    const isNotMobile = getIsNotMobile(); // TODO: remove getShouldOverrideToGosu0002Variant() check after running GOSU-0002 user testing

    const variantOverrideParamExists = getShouldOverrideToGosu0002Variant();
    return isCrmFlow && isNotMobile && !variantOverrideParamExists;
  }
}], [ExperimentKeys.ACQ0136, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isUsingGoogleAuth = isGoogleSignup(state);
    const isNewUser = getIsNewUser(state);
    const intentKey = getIntentKey();
    const isNotCampaignAssistantIntent = intentKey !== Intent.campaignAssistant;
    return isEnrolledFlow && isUsingGoogleAuth && isNewUser && isNotCampaignAssistantIntent;
  }
}], [ExperimentKeys.ACQ0137, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsNewUserExperiment(state);
    const intentKey = getIntentKey();
    const isNotCampaignAssistantIntent = intentKey !== Intent.campaignAssistant;
    return isEnrolledFlow && isNewUser && isNotCampaignAssistantIntent;
  }
}], [ExperimentKeys.ACQ0134, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsNewUserExperiment(state);
    const intentKey = getIntentKey();
    const isComingFromEmailSignatureGenerator = getIsComingFromEmailSignatureGenerator();
    return isEnrolledFlow && isNewUser && !intentKey && !isComingFromEmailSignatureGenerator;
  }
}], [ExperimentKeys.ACQ0138, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Marketing, Flow.Sales, Flow.Service]);
    const intentKey = getIntentKey();
    const isCampaignAssistantIntent = intentKey === Intent.campaignAssistant;
    const isNewUser = getIsNewUserExperiment(state);
    const isComingFromEmailSignatureGenerator = getIsComingFromEmailSignatureGenerator();
    return isEnrolledFlow && isNewUser && !isComingFromEmailSignatureGenerator && !isCampaignAssistantIntent;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }

  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}